import React from 'react';
import {
    IconMailCheckXXL,
    IconTeamXXL,
    IconEyeHideXXL,
    IconAnonymousXXL,
    IconPresentXXL,
    IconRocketXXL,
} from '../../../../icons';
import css from './SectionMainBenefits.css';

export default () => (
    <section className={css.root}>
        <h2 className={css.heading}>Deine Vorteile mit Credits</h2>
        <div className={css.grid}>
            <div className={css.gridItem}>
                <IconMailCheckXXL />
                <h3>Anfragen akzeptieren</h3>
                <p>
                    Akzeptiere Anfragen, um Mitgliedern antworten zu können.{' '}
                    {/* <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://support.horsedeal.com/hc/de/articles/27386985127314/"
                    >
                        Mehr erfahren
                    </a> */}
                </p>
            </div>
            <div className={css.gridItem}>
                <IconTeamXXL />
                <h3>Ansichten aufdecken</h3>
                <p>
                    Finde heraus, wer dein Profil oder Inserat angesehen hat.{' '}
                    {/* <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://support.horsedeal.com/hc/de/articles/27387087763090/"
                    >
                        Mehr erfahren
                    </a> */}
                </p>
            </div>
            <div className={css.gridItem}>
                <IconEyeHideXXL />
                <h3>Unsichtbar bleiben</h3>
                <p>
                    Verdecke Profil oder Inserat ganz ohne den Status zu ändern.{' '}
                    {/* <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://support.horsedeal.com/hc/de/articles/27387051412114/"
                    >
                        Mehr erfahren
                    </a> */}
                </p>
            </div>
            <div className={css.gridItem}>
                <IconAnonymousXXL />
                <h3>Anonym suchen</h3>
                <p>
                    Namen, Fotos und Videos bleiben bis zu einem Treffer verborgen.{' '}
                    {/* <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://support.horsedeal.com/hc/de/articles/27387130476050"
                    >
                        Mehr erfahren
                    </a> */}
                </p>
            </div>
            <div className={css.gridItem}>
                <IconPresentXXL />
                <h3>Treffer schenken</h3>
                <p>
                    Übernehme die Credits für den Treffer mit einem Mitglied.{' '}
                    {/* <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://support.horsedeal.com/hc/de/articles/27387157273618/"
                    >
                        Mehr erfahren
                    </a> */}
                </p>
            </div>
            <div className={css.gridItem}>
                <IconRocketXXL />
                <h3>Sichtbarkeit erhöhen</h3>
                <p>
                    Erhöhe deine Sichtbarkeit und erhöhe deine Chancen auf ein Match.{' '}
                    {/* <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://support.horsedeal.com/hc/de/articles/27387135344274/"
                    >
                        Mehr erfahren
                    </a> */}
                </p>
            </div>
        </div>
    </section>
);
